import * as yup from 'yup';
import moment from 'moment';
import { FilingStatus } from '../../api/usePersonalInfoQuery';

export interface UserFormValues {
  firstName: string;
  lastName: string;
  dob: string;
}

export interface YourInfoFormValues {
  principal: UserFormValues;
  filingState: number;
  filingStatus: FilingStatus;
}

export const dobValidation = yup
  .string()
  .test('DOB', 'Please enter a valid date of birth.', value => {
    const parsedDate = moment(value, 'MM/DD/YYYY', true);

    return parsedDate.isValid() && moment().diff(parsedDate, 'years') <= 120;
  });

export const principalValidation = yup
  .object()
  .shape({
    firstName: yup.string().required('Client First Name is required.'),
    lastName: yup.string(),
    dob: dobValidation,
  })
  .required();
